import React from 'react';
import { translate } from '../../Services/translation';

const CartGridItemDetails = ({item}) => (
  <>
  <div className='cart-grid-item__details'>
    <span>Art. {item.erpVariantId}</span>
    {item.externalArticleNumber && (
      <span>
        {translate('checkout.cart.extarticlenumber')}
        {order.externalArticleNumber}
      </span>
    )}
    {item.ceMarking == true && (
        <svg>
          <use href='/ui/images/sprites/be-group.svg#CE'></use>
        </svg>
    )}
    {item.isRemnantItem && (
      <span>
        {translate('product.remnantserial')}{' '}
        {item.remnantSerialNumber}
      </span>
    )}
    {item.remnantColor != 'transparent' && item.remnantColor &&
      <span>
        <span className='cart-grid-item__details__icon' style={{ backgroundColor: item.remnantColor }}></span>
        {translate('blasting.' + item.remnantColor.toLowerCase().replace(/\s+/g, ''))}
        {item.remnantThickness}
      </span>
    }
  </div>   
    {item.goodsMarking && 
    <div className='cart-grid-item__details'>
      <svg>
        <use href="/ui/images/sprites/be-group.svg#tick"></use>
      </svg>
      <span>
        {translate('checkout.cart.goodmark')}: {item.goodsMarking}
      </span>
    </div>}
    {item.orderRowTooltipText && <div className='information-item'>
      <svg>
        <use href='/ui/images/sprites/be-group.svg#attention' />
      </svg>  
      <span>{item.orderRowTooltipText}</span>
    </div>}
  </>
);

export default CartGridItemDetails;